module.exports = __webpack_public_path__ + "static/img/unknown-team.9882094.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/unknown-team.svg
// module id = 61
// module chunks = 2